(function() {
    'use strict';

    angular
        .module('fileUploadApp')
        .controller('RootConfigController', RootConfigController);

    RootConfigController.$inject = ['Principal', 'Auth','$http'];

    function RootConfigController (Principal, Auth, $http) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.getfolder = getfolder;
        vm.selectFile = selectFile;
        vm.settingsAccount = null;
        vm.success = null;
        vm.rootPath = null;
        vm.absolutePath = null;
        vm.setRootPath=setRootPath;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });
        
        getRootPath();
        getAbsolutePath();
        

        function save () {
            /*Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });*/
        }
        
       function selectFile (){
        	$("#filepath").click();
       }
        
        function getfolder(e) {
            var files = e.target.files;
            var path = files[0].webkitRelativePath;
            var Folder = path.split("/");
            console.log(files);
            console.log(path);
            console.log(Folder);
            console.log(files[0].mozFullPath);
        }
        
        function getRootPath(){
        	$http.get('api/getRootPath').then(function(response){
        		//console.log(response.data);
        		vm.rootPath=response.data.rootPath;
        	});
        }
        
        function getAbsolutePath(){
        	$http.get('api/getAbsolutePath').then(function(response){
        		//console.log(response.data);
        		vm.absolutePath=response.data.rootPath;
        	});
        }
        
        function setRootPath(){
        	$http({
    			url: 'api/setRootPath',
    			method: 'POST',
    			data: {
        			rootPath: vm.rootPath
    			}
    		}).then(function(response) {
    			
    			//$scope.loadRules();
    		})
        }
    }
})();
